import { Inject, Injectable, Optional } from "@angular/core";
import { get } from "lodash-es";

import { GLOBAL_CONFIG } from "../const";
import { LocationService } from "../location/location.service";
import { GlobalConfig } from "../model";

import { PrefetchResponse } from "./prefetch.model";

@Injectable({
	providedIn: "root",
})
export class PrefetchService {
	constructor(
		@Optional() @Inject(GLOBAL_CONFIG) private globalConfig: GlobalConfig,
		private locationService: LocationService
	) {}

	/**
	 * Attempts to retrieve api data from prefetch cache.
	 */
	get(url: string): PrefetchResponse | undefined {
		if (!this.globalConfig.prefetchData) {
			return undefined;
		}

		const { href, origin } = new URL(url, this.locationService.getOrigin());
		const relativeUrl = href.replace(origin, "");
		const prefetchData = this.globalConfig.prefetchData[relativeUrl];

		if (prefetchData) {
			return this.wrapPrefetchData(prefetchData);
		}

		// exact match failed, attempting partial matches
		let pathnameDiff: string;
		if (relativeUrl.substring(relativeUrl.length - 1) === "/") {
			pathnameDiff = relativeUrl.slice(0, -1);
		} else {
			pathnameDiff = `${relativeUrl}/`;
		}

		return this.wrapPrefetchData(get(this.globalConfig.prefetchData, pathnameDiff, undefined));
	}

	isPrefetchResponse(data: any): data is PrefetchResponse {
		return data?.type === "prefetch";
	}

	wrapPrefetchData(prefetchData: any): PrefetchResponse | undefined {
		if (!prefetchData) {
			return undefined;
		}

		return {
			type: "prefetch",
			data: prefetchData,
		};
	}
}
